var exports = {
  "kL": "x31de4314--4cb08b--container",
  "Ew": "x31de4314--4cb08b--notification",
  "A4": "x31de4314--4cb08b--control",
};

module.exports = exports;
